import { render } from "./ChamadosPrazo.vue?vue&type=template&id=337d7358"
import script from "./ChamadosPrazo.vue?vue&type=script&lang=js"
export * from "./ChamadosPrazo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__